import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withViewport } from '../../util/contextHelpers';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/UI.duck';
import { injectIntl, intlShape } from '../../util/reactIntl';
import config from '../../config';
import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
} from '../../components';
import { TopbarContainer } from '..';
import SectionHero from './SectionHero';
import SectionHowToEnrol from './SectionHowToEnrol';
import SectionHowToEnrolDesktop from './SectionHowToEnrolDesktop';
import SectionGuideToDisinfectMobile from './SectionGuideToDisinfectMobile';
import SectionGuideToDisinfectDesktop from './SectionGuideToDisinfectDesktop';
import SectionHowToApplyViroQ from './SectionHowToApplyViroQ';
import { SectionBrowseCar } from './SectionBrowseCar';
import { loadData } from './CovidPage.duck';
import facebookImage from '../../assets/facebook_drivelah_2.jpg';
import twitterImage from '../../assets/facebook_drivelah_2.jpg';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { login } from '../../ducks/Auth.duck';
import css from './CovidPage.css';

export const LandingPageComponent = props => {
  const { history, intl, scrollingDisabled, listings, onManageDisableScrolling } = props;

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'LandingPageCovid.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'LandingPageCovid.schemaDescription' });
  const schemaImage = `${config.canonicalRootURL}${facebookImage}`;

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        { url: `${config.canonicalRootURL}${twitterImage}`, width: 600, height: 314 },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <SectionHero />
          <div className={css.sectionBrowseCarDesktop}>
            <SectionBrowseCar intl={intl} listings={listings}/>
          </div>
          <SectionGuideToDisinfectDesktop />
          <SectionHowToEnrolDesktop />
          <SectionHowToEnrol />
          <SectionGuideToDisinfectMobile />
          <SectionHowToApplyViroQ onManageDisableScrolling={onManageDisableScrolling} />
          <div className={css.sectionBrowseCarMobile}>
            <SectionBrowseCar intl={intl} listings={listings}/>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool, object } = PropTypes;

LandingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from withRouter
  history: object.isRequired,
  location: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {

  const { listingRefs, fetchInProgress, fetchError } = state.CovidPage;
  const listings = getMarketplaceEntities(state, listingRefs);
  const scrollingDisabled = isScrollingDisabled(state);
  return {
    fetchInProgress,
    fetchError,
    listings,
    scrollingDisabled,
  }
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onLogin: (email, password) => dispatch(login(email, password))
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CovidLandingPage = compose(
  withViewport,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(LandingPageComponent);

CovidLandingPage.loadData = loadData;

export default CovidLandingPage;
